/** Painted ground tiles plus two small fixed border materials. */
export const COASTAL_TERRAIN_REVISION = 6;
export const COASTAL_GRASS_FILTER = "brightness(0.88) saturate(0.92)";
export const COASTAL_TERRAIN_ASSETS = {
    grass: "/img/momo/terrain-v6/grass.png",
    sand: "/img/momo/terrain-v6/sand.png",
    water: "/img/momo/terrain-v6/water.png"
} as const;
export const COASTAL_BORDER_ASSETS = {
    turf: "/img/momo/terrain-v6/turf-edge.png",
    surf: "/img/momo/terrain-v6/surf-edge.png"
} as const;
export const COASTAL_GROUND_TILE_SIZE = { grass: 64, sand: 96, water: 112 } as const;
export const COASTAL_GROUND_BASE_BYTES = 3 * 512 * 512 * 4;
export const COASTAL_BORDER_BASE_BYTES = 2 * 512 * 256 * 4;
